<!-- w-fit keeps the title and the table the same width: the block hugs the table when it fits and is
     capped at the available width when it doesn't, so the table alone scrolls sideways. It stays off
     while loading because sb-section-toolbar is a container-query container, which contributes no
     intrinsic width — the block would collapse to the width of the spinner. -->
<div class="mx-auto max-w-full" [class.w-fit]="!loading">
  <sb-section-toolbar class="mb-md">
    <span class="inline-flex items-center gap-xs">
      {{ 'Teams and permissions' | translate }}
      <knowledge-base-article article="user-permissions" />
    </span>
  </sb-section-toolbar>

  @if (loading) {
    <sb-loading-state class="py-2xl" />
  } @else {
    @let departmentGroup = form.get('Department');

    <div sbTableContainer [innerScroll]="true">
      <table sbTable>
        <thead>
          <tr sbTableRow>
            <th sbTableHeaderCell sbStickyColumn class="min-w-40">
              <span class="sr-only">{{ 'Department' | translate }}</span>
            </th>
            <th sbTableHeaderCell [align]="'center'" class="min-w-48">
              <span class="inline-flex items-center gap-2xs">
                {{ 'Team' | translate }}
                @if (departmentGroup?.invalid && departmentGroup?.errors?.['missingTeam']) {
                  <sb-icon
                    class="text-danger"
                    name="alert-regular"
                    [sbTooltipPlacement]="'top'"
                    [sbTooltip]="'Select at least one team' | translate"
                  />
                }
              </span>
            </th>
            @for (group of groups; track group.id) {
              <th sbTableHeaderCell [align]="'center'" class="min-w-30">
                <span class="whitespace-normal">{{ group.name }}</span>
              </th>
            }
          </tr>
        </thead>

        @for (location of locations; track trackByLocation($index, location)) {
          <tbody [formGroup]="locationGroupForm.get(location.location.id)">
            <tr sbTableRow>
              <td sbTableCell sbStickyColumn [section]="true">{{ location.location.name }}</td>
              <td sbTableCell [section]="true"></td>
              @for (group of groups; track group.id) {
                <td sbTableCell [section]="true" [align]="'center'">
                  <sb-checkbox
                    [formControlName]="group.id"
                    (change)="toggleGroupForLocation(location.location.id, group.id, $event)"
                  />
                </td>
              }
            </tr>

            @for (department of location.departments; track trackById($index, department)) {
              @let departmentControl = form.get(['Department', department.id]);

              <tr sbTableRow>
                <td sbTableCell sbStickyColumn class="font-semibold">
                  <span class="inline-flex items-center gap-2xs">
                    {{ department.name }}
                    @if (
                      departmentControl.invalid &&
                      departmentControl.dirty &&
                      departmentControl.errors?.['missingPermission']
                    ) {
                      <sb-icon
                        class="text-danger"
                        name="alert-regular"
                        [sbTooltipPlacement]="'top'"
                        [sbTooltip]="'The employee needs permissions for each team he or she is added to' | translate"
                      />
                    }
                  </span>
                </td>
                <td sbTableCell>
                  <select
                    sbInput
                    class="w-full"
                    [formControl]="departmentControl.get('team_id')"
                    [name]="department.id + '|team_id'"
                  >
                    <option [value]=""></option>
                    @for (team of teamsPerDepartment[department.id]; track team.id) {
                      <option [value]="team.id">{{ team.name }}</option>
                    }
                  </select>
                </td>
                @for (group of groups; track group.id) {
                  <td sbTableCell [align]="'center'">
                    <sb-checkbox [formControl]="departmentControl.get(['UsersGroup', group.id])" />
                  </td>
                }
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }
</div>
